import { gql } from '@apollo/client'

import { DICTIONARY_WORDS_FRAGMENT } from '../fragments'

const MOVE_DICTIONARY_WORD_TO_TYPE_MUTATION = gql`
  mutation moveDictionaryWordToType(
    $id: ID!
    $type: DictionaryWordType!
    $pageSize: Int
    $previousType: DictionaryWordType!
    $previousTypePageSize: Int
    $previousTypePage: Int
    $filters: DictionaryWordFiltersInput
  ) {
    moveDictionaryWordToType(
      id: $id
      type: $type
      pageSize: $pageSize
      previousType: $previousType
      previousTypePageSize: $previousTypePageSize
      previousTypePage: $previousTypePage
      filters: $filters
    ) {
      preparationMethods {
        ...DictionaryWordsFragment
      }
      commonEnglishWords {
        ...DictionaryWordsFragment
      }
      commonForeignWords {
        ...DictionaryWordsFragment
      }
      names {
        ...DictionaryWordsFragment
      }
      notRelevant {
        ...DictionaryWordsFragment
      }
      wholeDishNames {
        ...DictionaryWordsFragment
      }
      ambigous {
        ...DictionaryWordsFragment
      }
      conflictingLabels {
        ...DictionaryWordsFragment
      }
      ingredientMeasurements {
        ...DictionaryWordsFragment
      }
    }
  }
  ${DICTIONARY_WORDS_FRAGMENT}
`

export default MOVE_DICTIONARY_WORD_TO_TYPE_MUTATION
